/* eslint-disable react/jsx-no-useless-fragment */

/* eslint-disable react-hooks/exhaustive-deps */

/* eslint-disable react/no-array-index-key */
import axios from 'axios';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Card,
  Checkbox,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';

import React, { useEffect, useState } from 'react';

import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import { useAuth } from '@src/contexts/authContext';
import { formatDate } from '@src/utils';

const url = `${process.env.REACT_APP_API_URL}`;

function VariableForm({ template, setTemplate }) {
  const handleEditableToggle = (id) => {
    setTemplate((prev) => {
      const updatedVars =
        prev?.ct_template_variables?.variables?.map((ct) =>
          ct.idx === id
            ? { ...ct, value_is_editable: !ct.value_is_editable }
            : ct,
        ) || [];

      return {
        ...prev,
        ct_template_variables: {
          ...prev.ct_template_variables,
          variables: updatedVars,
        },
      };
    });
  };

  return (
    <>
      {template?.the_id && (
        <Box mt={1} pl={2}>
          <Typography sx={{ mt: 3 }}>Body</Typography>

          <TextField
            fullWidth
            multiline
            disabled
            rows={6}
            size='medium'
            variant='outlined'
            placeholder='Enter the body with variables like {{1}}, {{2}}, etc.'
            sx={{
              '& .MuiOutlinedInput-root': { borderRadius: '6px' },
              mt: 1,
            }}
            value={template?.ct_template_definition?.body || ''}
            onChange={(e) =>
              setTemplate((prev) => ({
                ...prev,
                ct_template_definition: {
                  ...prev.ct_template_definition,
                  body: e.target.value,
                },
              }))
            }
          />

          {template?.ct_template_variables?.variables?.map((ct) => {
            return (
              <>
                <Box key={ct.idx} sx={{ mt: 3 }}>
                  <div className='flex items-center justify-between'>
                    <div className='flex items-center'>
                      <Typography fontSize={14} fontWeight={600}>
                        {ct.var_code}
                      </Typography>
                      &nbsp;&nbsp;
                      <Typography
                        fontSize={14}
                        display='flex'
                        fontWeight={300}
                        color='gray'
                      >
                        {ct.label}
                      </Typography>
                    </div>
                    <Box display='flex' alignItems='center'>
                      <Checkbox
                        checked={!!ct.value_is_editable}
                        onChange={() => handleEditableToggle(ct.idx)}
                        sx={{ color: '#1788b9' }}
                      />
                      <Typography fontSize={14}>Editable</Typography>
                    </Box>
                  </div>

                  <TextField
                    fullWidth
                    value={ct?.example_value || ''}
                    onChange={(e) => {
                      setTemplate((prev) => ({
                        ...prev,
                        ct_template_variables: {
                          ...prev.ct_template_variables,
                          variables: prev.ct_template_variables.variables.map(
                            (v) =>
                              v.idx === ct.idx
                                ? { ...v, example_value: e.target.value }
                                : v,
                          ),
                        },
                      }));
                    }}
                    sx={{
                      '& .MuiOutlinedInput-root': { borderRadius: '6px' },
                      mt: 1,
                    }}
                  />

                  <Typography
                    fontSize={14}
                    mt={1}
                    fontWeight={300}
                    color='gray'
                  >
                    Value Type{' '}
                  </Typography>

                  <Select
                    fullWidth
                    size='medium'
                    displayEmpty
                    value={ct.value_type || ''}
                    onChange={(e) => {
                      setTemplate((prev) => ({
                        ...prev,
                        ct_template_variables: {
                          ...prev.ct_template_variables,
                          variables: prev.ct_template_variables.variables.map(
                            (v) =>
                              v.idx === ct.idx
                                ? { ...v, value_type: e.target.value }
                                : v,
                          ),
                        },
                      }));
                    }}
                    sx={{ mt: 1, borderRadius: '8px' }}
                  >
                    <MenuItem disabled value=''>
                      <em style={{ color: '#8C8C8C' }}>Select</em>
                    </MenuItem>
                    <MenuItem value='user_defined'>User Defined</MenuItem>
                    <MenuItem value='system_defined'>System Defined</MenuItem>
                  </Select>
                </Box>
              </>
            );
          })}
        </Box>
      )}
    </>
  );
}

function getPreviewMessage(template) {
  let message = template?.ct_template_definition?.body || '';

  const variables = template?.ct_template_variables?.variables || [];

  variables.forEach((v) => {
    message = message.replaceAll(`{{${v.idx}}}`, v.example_value || '');
  });

  const parts = message.split(/(\*.*?\*)/g);

  return parts.map((part, i) => {
    if (part.startsWith('*') && part.endsWith('*')) {
      return <b key={i}>{part.slice(1, -1)}</b>;
    }
    return <span key={i}>{part}</span>;
  });
}

export default function EditCampaignTemplate() {
  const { auth } = useAuth();
  const { pathname: state } = useLocation();
  const navigate = useNavigate();

  const { templateId } = useParams();
  const [template, setTemplate] = useState([]);

  const fetchData = () => {
    if (auth.idToken && templateId) {
      axios
        .get(`${url}/admin/v3/messages/twilio/templates/${templateId}`, {
          headers: {
            Authorization: `Bearer ${auth.idToken}`,
          },
        })
        .then((response) => {
          setTemplate(response.data?.response?.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  useEffect(() => {
    fetchData();
  }, [auth.idToken, templateId]);

  const handlePost = () => {
    const formData = {
      env_code: template?.env_code,
      the_id: template?.the_id,
      ct_name: template?.ct_name,
      ct_code: template?.ct_code,
      ct_description: template?.ct_description,
      ct_category: template?.ct_category,
      ct_language: template?.ct_language || 'en',
      ct_template_type: template?.ct_template_type,
      ct_template_definition: {
        body: template?.ct_template_definition?.body || '',
      },
      ct_template_variables: {
        meta: {
          variable_count:
            template?.ct_template_variables?.variables?.length || 0,
        },
        variables: (template?.ct_template_variables?.variables || []).map(
          (v, index) => ({
            idx: index + 1,
            name: (index + 1).toString(),
            label: v.label,
            idx_str: String(index + 1).padStart(3, '0'),
            var_code: `{{${index + 1}}}`,
            value_type: v.value_type || 'user_defined',
            default_value: v.default_value || 'user_input',
            example_value: v.example_value,
            value_ui_type: v.value_ui_type || 'text',
            value_is_editable:
              typeof v.value_is_editable === 'boolean'
                ? v.value_is_editable
                : true,
          }),
        ),
      },
      ct_need_approval: template?.ct_need_approval,
      ct_approval_status: template?.ct_approval_status,
      ct_is_active: template?.ct_is_active,
      ct_is_linked_template: template?.ct_is_linked_template,
      ct_linked_provider: template?.ct_linked_provider || 'twilio',
      ct_linked_provider_the_id: template?.ct_linked_provider_id,
      ww_system_notes: template?.ww_system_notes || null,
    };

    axios
      .put(
        `${url}/admin/v3/messages/twilio/templates/${templateId}`,
        formData,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${auth.idToken}`,
          },
        },
      )
      .then((response) => {
        console.log('Item updated successfully:', response);
        setTemplate({ ...template });
        toast.success('Item updated successfully', {
          position: 'top-center',
          autoClose: 2000,
        });
      })
      .catch((error) => {
        console.log(error.message);
        toast.error(
          `${error.response?.data?.system?.message || 'An error occurred'}`,
          {
            position: 'top-center',
            autoClose: 2000,
          },
        );
      });
  };

  const handleBack = async () => {
    navigate(state?.prevLocation || -1);
  };

  const bodyText = (template?.ct_template_definition?.body || '').trim();
  const bodyWords = bodyText.split(/\s+/).filter(Boolean);

  const valuesText = (template?.ct_template_variables?.variables || [])
    .map((v) => v.value || '')
    .join(' ')
    .trim();
  const valueWords = valuesText.split(/\s+/).filter(Boolean);

  const totalWords = bodyWords.length + valueWords.length;

  return (
    <div>
      <Box fullwidth margin={2}>
        <Button
          sx={{
            textTransform: 'none',
            paddingLeft: 0,
          }}
          className='px-6 font-bold text-purple-500'
          variant='text'
          // eslint-disable-next-line react/jsx-no-bind
          onClick={handleBack}
        >
          Back
        </Button>

        <Card
          sx={{
            backgroundColor: 'white',
            p: 3,
            borderRadius: 4,
            ml: 3,
            width: '95%',
            mt: 5,
          }}
        >
          <Accordion
            // defaultExpanded
            sx={{
              boxShadow: 'none',
              border: 'none',
              '&:before': {
                display: 'none',
              },
            }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ px: 0 }}>
              <Typography
                pl={2}
                fontWeight={600}
                fontSize={20}
                fontFamily='Poppins'
              >
                General Information
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container spacing={4} pt={2}>
                <Grid item xs={12} md={4}>
                  <Box>
                    <Typography fontFamily='Poppins'>Template name</Typography>
                    <Typography color='gray' mt={1} fontFamily='Poppins'>
                      {template.ct_name || '-'}
                    </Typography>
                  </Box>
                  <Box mt={3}>
                    <Typography fontFamily='Poppins'>Template code</Typography>
                    <Typography
                      color='gray'
                      mt={1}
                      fontFamily='Poppins'
                      sx={{
                        display: '-webkit-box',
                        WebkitLineClamp: 3,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                      }}
                    >
                      {template.ct_code || '-'}
                    </Typography>
                  </Box>

                  <Box mt={3}>
                    <Typography fontFamily='Poppins'>
                      WhatsApp category
                    </Typography>
                    <Typography color='gray' mt={1} fontFamily='Poppins'>
                      {template.ct_category || '-'}
                    </Typography>
                  </Box>
                  <Box mt={3}>
                    <Typography fontFamily='Poppins'>
                      WhatsApp Approval Status
                    </Typography>
                    <Box
                      sx={{
                        backgroundColor:
                          template?.ct_approval_status === 'approved'
                            ? '#DCFCE7'
                            : template?.ct_approval_status === 'unsubmitted'
                            ? '#E0F2FE'
                            : '#FEF3C7',
                        color:
                          template?.ct_approval_status === 'approved'
                            ? '#15803D'
                            : template?.ct_approval_status === 'unsubmitted'
                            ? '#0369A1'
                            : '#92400E',
                        borderRadius: '12px',
                        px: 1.5,
                        py: 0.5,
                        mt: 1,
                        display: 'inline-block',
                        fontWeight: 600,
                        fontSize: '0.75rem',
                        textTransform: 'capitalize',
                      }}
                    >
                      {template?.ct_approval_status}
                    </Box>
                  </Box>
                </Grid>

                <Grid item xs={12} md={4}>
                  <Box>
                    <Typography fontFamily='Poppins'>
                      Template language
                    </Typography>
                    <Typography color='gray' mt={1} fontFamily='Poppins'>
                      {template.ct_language || '-'}
                    </Typography>
                  </Box>
                  <Box mt={3}>
                    <Typography fontFamily='Poppins'>Content type</Typography>
                    <Typography color='gray' mt={1} fontFamily='Poppins'>
                      {template.ct_template_type || '-'}
                    </Typography>
                  </Box>
                  <Box mt={3}>
                    <Typography fontFamily='Poppins'>Description</Typography>
                    <Typography
                      color='gray'
                      mt={1}
                      fontFamily='Poppins'
                      sx={{
                        display: '-webkit-box',
                        WebkitLineClamp: 3,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                      }}
                    >
                      {template.ct_description || '-'}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={12} md={4}>
                  <Box>
                    <Typography fontFamily='Poppins'>Account</Typography>
                    <Typography color='gray' mt={1} fontFamily='Poppins'>
                      {template.account?.acc_name || '-'}
                    </Typography>
                  </Box>
                  <Box mt={3}>
                    <Typography fontFamily='Poppins'>Is active</Typography>
                    <Typography color='gray' mt={1} fontFamily='Poppins'>
                      {template.ct_is_active ? 'true' : 'false'}
                    </Typography>
                  </Box>
                  <Box mt={3}>
                    <Typography fontFamily='Poppins'>Created at</Typography>
                    <Typography color='gray' mt={1} fontFamily='Poppins'>
                      {formatDate(template.ww_created_at) || '-'}
                    </Typography>
                  </Box>
                  <Box mt={3}>
                    <Typography fontFamily='Poppins'>
                      Last updated at
                    </Typography>
                    <Typography color='gray' mt={1} fontFamily='Poppins'>
                      {formatDate(template.ww_updated_at) || '-'}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
        </Card>

        <Card
          sx={{
            backgroundColor: 'white',
            p: 3,
            borderRadius: 4,
            ml: 3,
            width: '95%',
            mt: 2,
          }}
        >
          <div className='grid grid-cols-2 gap-6 pt-8'>
            <Box>
              <Typography
                pl={2}
                fontWeight={600}
                fontSize={20}
                fontFamily='Poppins'
              >
                Content
              </Typography>
              <VariableForm template={template} setTemplate={setTemplate} />
            </Box>

            <div>
              <Typography
                pl={2}
                fontWeight={600}
                fontSize={20}
                fontFamily='Poppins'
              >
                Message Preview
              </Typography>
              <br />
              <Box
                sx={{
                  border: '10px solid black',
                  borderRadius: '30px',
                  width: '25vw',
                  height: '80vh',
                  margin: '0 auto',
                  backgroundColor: '#ffffff',
                  display: 'flex',
                  flexDirection: 'column',
                  overflow: 'hidden',
                  maxWidth: 390,
                  maxHeight: 800,
                }}
              >
                {/* HEADER HP */}
                <Box
                  sx={{
                    p: 2,
                    borderBottom: '1px solid #ccc',
                    background: '#fff',
                    borderTopLeftRadius: '20px',
                    borderTopRightRadius: '20px',
                    display: 'flex',
                    justifyContent: 'space-between',
                  }}
                >
                  <Typography fontSize={14} fontWeight={600}>
                    {template.ct_name || 'Template Name'}
                  </Typography>
                  <Typography pl={5} fontSize={14} fontWeight={600}>
                    {totalWords || '0'}/1024
                  </Typography>
                </Box>

                {/* BODY PREVIEW */}
                <Box sx={{ flex: 1, p: 2, overflowY: 'auto' }}>
                  <Typography fontSize={14} whiteSpace='pre-line'>
                    {getPreviewMessage(template)}
                  </Typography>
                </Box>
              </Box>
            </div>
          </div>
          <br />
        </Card>

        <Card
          sx={{
            display: 'flex',
            justifyContent: 'end',
            mt: 5,
            pr: 15,
            height: '100px',
            p: 3,
            width: '95%',
            borderRadius: 4,
            ml: 3,
          }}
        >
          <Button
            sx={{
              textTransform: 'none',
              mr: 2,
              height: '50px',
              width: '150px',
            }}
            className='rounded-xl bg-red-600 px-6 font-bold text-white'
            onClick={handleBack}
          >
            Cancel
          </Button>
          <Button
            sx={{ textTransform: 'none', height: '50px', width: '150px' }}
            className='rounded-xl bg-cyan-600 px-6 font-bold text-white'
            onClick={handlePost}
          >
            Save
          </Button>
        </Card>
      </Box>
      <br />
    </div>
  );
}
